import { z } from "zod";

const translationPath = "page.4uDlist.list.errors.";

const categoriesSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const classificationsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.number().nullish(),
});

const integrationTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "integration_type" }
);

export const listSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name"),
  description: z.string().nullish(),
  integrationType: integrationTypeSchema,
  listCategories: z
    .array(categoriesSchema)
    .min(1, translationPath + "list_categories"),
  listClassifications: z
    .array(classificationsSchema)
    .min(1, translationPath + "list_classifications"),
});

export type TListForm = z.infer<typeof listSchema>;
